import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ComponentFactoryResolver,
  OnDestroy,
  Type,
  ViewContainerRef,
} from "@angular/core";

import { ZoneDirective } from "@/shared-module/directives/zone.directive";
import { ZoneItem } from "./zone-item";
import { ZoneComponent } from "./zone-component";
import { ZoneError } from "@/shared-module/models";
import { BigNumberComponent } from "@/shared-module/components/bignumber/bignumber.component";
import { RankComponent } from "@/shared-module/components/rank/rank.component";
import { RankIndicesComponent } from "@/shared-module/components/rank-indices/rank-indices.component";
import { LineChartComponent } from "@/shared-module/components/linechart/linechart.component";
import { PlaceHolderComponent } from "@/shared-module/components/placeholder/placeholder.component";
import { TableComponent } from "@/shared-module/components/table/table.component";

import { BubbleChartComponent } from "@/shared-module/components/bubblechart/bubblechart.component";
import { DonutChartComponent } from "@/shared-module/components/donutchart/donutchart.component";
import { MultiChartComponent } from "@/shared-module/components/multichart/multichart.component";
import { MultiChart2LevelsLegendComponent } from "@/shared-module/components/multichart2levelslegend/multichart2levelslegend.component";
import { StackedChartComponent } from "@/shared-module/components/stackedchart/stackedchart.component";
import { TeamSelectorComponent } from "@/shared-module/components/teamselector/teamselector.component";
import { WaterfallComponent } from "@/shared-module/components/waterfall/waterfall.component";
import { RoceChartComponent } from "@/shared-module/components/rocechart/rocechart.component";
import { ZoneErrorComponent } from "./zone-error.component";

@Component({
  selector: "app-zone-container",
  templateUrl: "zonecontainer.component.html",
  styles: [
    `
      @media screen and (min-width: 992px) {
        :host {
          width: 100%;
          display: flex;
        }
      }
    `,
  ],
})
export class ZoneContainerComponent implements OnInit, OnDestroy {
  @Input() zoneItems: ZoneItem[];
  @ViewChild(ZoneDirective, { static: true }) appZone: ZoneDirective;
  //@ViewChild('ctner', {static: true}) appZone: any;
  interval: any;

  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit() {
    this.loadComponent();
  }

  ngOnDestroy() {}

  loadComponent() {
    this.zoneItems.forEach((zone) => {
      if (zone.error) {
        zone.data = new ZoneError();
        zone.data.error = zone.error;
        zone.data.component = zone.component;
        zone.component = "ZoneErrorComponent";
      }

      // tslint:disable-next-line:no-string-literal

      // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(zone.component);

      // const factories = Array.from(this.componentFactoryResolver['_factories'].keys());
      // const factoryClass = factories.find((x: any) => x.name === zone.component) as Type<any>;
      const factory = this.componentFactoryResolver.resolveComponentFactory(
        entryComponentsMap[zone.component],
      );
      // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(factory);

      const viewContainerRef = this.appZone.viewContainerRef;
      // viewContainerRef.clear();

      const componentRef = viewContainerRef.createComponent(factory);

      (componentRef.instance as ZoneComponent).data = zone.data;
      (componentRef.instance as ZoneComponent).width = zone.width;
      (componentRef.instance as ZoneComponent).needpaddingLeft =
        zone.needpaddingLeft;
      (componentRef.instance as ZoneComponent).isZoom = zone.isZoom;
    });
  }
}

export const entryComponentsMap = {
  BigNumberComponent: BigNumberComponent,
  RankComponent: RankComponent,
  RankIndicesComponent: RankIndicesComponent,
  LineChartComponent: LineChartComponent,
  BubbleChartComponent: BubbleChartComponent,
  DonutChartComponent: DonutChartComponent,
  MultiChartComponent: MultiChartComponent,
  MultiChart2LevelsLegendComponent: MultiChart2LevelsLegendComponent,
  RoceChartComponent: RoceChartComponent,
  StackedChartComponent: StackedChartComponent,
  TableComponent: TableComponent,
  TeamSelectorComponent: TeamSelectorComponent,
  WaterfallComponent: WaterfallComponent,
  ZoneErrorComponent: ZoneErrorComponent,
  PlaceHolderComponent: PlaceHolderComponent,
};
